/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import { baseUrlApi } from './base';

export const getHubeeStatus = () => `${baseUrlApi}/hubee/status`;

export const pingHubee = () => `${baseUrlApi}/hubee/ping`;
